import axios from './axios';

export interface Visit {
  id: number;
  agent_id: number;
  client_id: number;
  planned_date: string;
  checkin_at?: string;
  checkin_photo_url?: string;
  checkin_lat?: number;
  checkin_lng?: number;
  checkout_at?: string;
  checkout_photo_url?: string;
  checkout_lat?: number;
  checkout_lng?: number;
  result?: string;
  note?: string;
  status?: string;
  refusal_reason_id?: number;
  checkin_distance?: number;
  checkout_distance?: number;
  equipment_photo_url?: string;
  is_virtual?: boolean;
  orders?: {
    id: number;
    total: number;
    status: string;
  }[];
  client: {
    id: number;
    name: string;
    address: string;
    phone: string;
    location_lat?: number;
    location_lng?: number;
  };
  agent: {
    id: number;
    name: string;
  };
}

export type VisitPhotoField = 'checkin_photo_url' | 'checkout_photo_url' | 'equipment_photo_url';

export const visitsApi = {
  updatePhoto: async (id: number, field: VisitPhotoField, url: string) => {
    const response = await axios.patch<Visit>(`/visits/${id}/photo`, { field, url });
    return response.data;
  },
  getAll: async (agentId?: number, date?: string, branchId?: number) => {
    const params: Record<string, string | number> = {};
    if (agentId) params.agent_id = agentId;
    if (date) params.date = date;
    if (branchId) params.branch_id = branchId;
    const response = await axios.get<Visit[]>('/visits', { params });
    return response.data;
  },

  getOne: async (id: number) => {
    const response = await axios.get<Visit>(`/visits/${id}`);
    return response.data;
  },

  checkin: async (id: number, data: { lat?: number; lng?: number; photo_url?: string }) => {
    const response = await axios.post<Visit>(`/visits/${id}/checkin`, data);
    return response.data;
  },

  checkout: async (
    id: number,
    data: {
      result: string;
      note?: string;
      photo_url?: string;
      lat?: number;
      lng?: number;
      status?: string;
      refusal_reason_id?: number;
    },
  ) => {
    const response = await axios.post<Visit>(`/visits/${id}/checkout`, data);
    return response.data;
  },
};
